import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';
import { pickupAPI } from '../api/pickupAPI';

import { searchBranchAdapter } from '../libs/branchSearchAdapter';
import { captureApiError, captureError } from '../../../lib/sentry-utils';

export const useSearchBranch = (search?: string) => {
  const initData = useMemo(() => ({ branches: searchBranchAdapter() }), []);
  const { data = initData, isLoading } = useQuery({
    queryKey: ['branches-search', search],
    queryFn: async () => {
      try {
        return await pickupAPI.search(search);
      } catch (error) {
        console.error('Branch search error:', {
          search_query: search,
          error: (error as any)?.message || String(error),
          status: (error as any)?.response?.status,
          statusText: (error as any)?.response?.statusText
        });
        captureApiError(error, '/branch/search', 'GET');
        throw error;
      }
    },
    select: data => {
      try {
        if (!data?.data || !data.data.success) {
          console.warn('Invalid branch search API response:', {
            endpoint: '/branch/search',
            search_query: search,
            status: data?.status,
            statusText: data?.statusText,
            success: data?.data?.success,
            message: data?.data?.message
          });
          captureError('Invalid branch search API response', { 
            endpoint: '/branch/search',
            search_query: search,
            status: data?.status,
            statusText: data?.statusText,
            success: data?.data?.success,
            message: data?.data?.message,
            responseData: data?.data 
          });
          return { branches: searchBranchAdapter() };
        }

        return {
          branches: searchBranchAdapter(data.data),
        };
      } catch (error) {
        console.error('Error processing branch search data:', {
          endpoint: '/branch/search',
          search_query: search,
          error: (error as any)?.message || String(error)
        });
        captureError('Error processing branch search data', { 
          endpoint: '/branch/search',
          search_query: search,
          error: error instanceof Error ? error.message : String(error) 
        });
        return { branches: searchBranchAdapter() };
      }
    },
  });
  return {
    ...data,
    isLoading,
  };
};
